module.exports = __webpack_public_path__ + "img/shouyang.30e22904.png";